import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './hooks/useAuth';
import App from './App';
import * as Sentry from '@sentry/react';
import 'react-image-crop/dist/ReactCrop.css';
import 'leaflet/dist/leaflet.css';
import './index.css';
import './i18n';

Sentry.init({
  dsn: "https://71a7bed7c3b99d4b93f16adeef494358@o4511412173078528.ingest.us.sentry.io/4511412186513408",
  ignoreErrors: [
    'Failed to update a ServiceWorker',
    "Lock broken by another request with the 'steal' option",
    'Lock broken by another request with the "steal" option',
  ],
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring (medir latencia y velocidad)
  tracesSampleRate: 1.0, // Captura el 100% de las transacciones
  // Session Replay (graba video de los errores)
  replaysSessionSampleRate: 0.1, // Graba el 10% de las sesiones normales
  replaysOnErrorSampleRate: 1.0, // Graba el 100% de las sesiones si ocurre un error
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>,
);